export default {
  // START:: GET APP LOCALE
  getAppLocale(state) {
    return state.glow_up_dashboard_language;
  },
  // END:: GET APP LOCALE
};
